module.exports = __webpack_public_path__ + "static/media/Artboard2.63575756.png";